import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { ChecklistModalComponent } from './checklist-modal.component';
import { SlideControlBarComponent } from './components/slide-control-bar/slide-control-bar.component';
import { ChecklistQuestionComponent } from './components/checklist-question/checklist-question.component';
import { SignatureModule } from '../signature/signature.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, IonicModule, FormsModule, SignatureModule, TranslateModule],
  declarations: [ChecklistModalComponent, SlideControlBarComponent, ChecklistQuestionComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ChecklistModalModule {}
